import './MemberServiceAccount.scss';
import Checkmark from '../../img/Checkmark.svg';
import Lock from '../../img/Lock.svg';
import SuccessMail from '../../img/SuccessMail.svg';

import { useLocation, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';

const AccountUnlockRecoveryResponse = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const headingRef = useRef(null);

  const status = location?.state?.status;
  const { adminConfigData } = useSelector((state) => state.user);
  const coolOffPeriod =
    adminConfigData?.Response?.AccountUnLockConfiguration?.CooloffPeriodMinutes;

  useEffect(() => {
    if (!status) {
      navigate('/member/');
    }
  }, [location, navigate]);
  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, []);
  return (
    <Container className="account-locked-page">
      <div className="account-locked-content unlock-success-content">
        {status && (
          <div className="unlock-success-icon">
            <img
              className="help-card-logo"
              src={status === 'success' ? SuccessMail : Lock}
              alt="success icon"
            />
          </div>
        )}

        <div className="unlock-success-title">
          {status === 'success' ? (
            <>
              <div
                role="heading"
                aria-level={1}
                className="sr-only"
                tabIndex={-1}
                ref={headingRef}
              >
                If an account exists you will receive an email.
              </div>
              <h1 aria-hidden={true} className="account-locked-title">
                If an account exists you will
                <br />
                receive an email.
              </h1>
              <div className="success-page-footer">
                <span>
                  Check your mail for instructions to unlock your account.
                </span>
                <button
                  type="button"
                  className="unlock-account-btn"
                  onClick={() => navigate('/member')}
                >
                  LOGIN
                </button>
              </div>
            </>
          ) : status === 'fail' ? (
            <>
              <div
                role="heading"
                aria-level={1}
                className="sr-only"
                tabIndex={-1}
                ref={headingRef}
              >
                You have exceeded the maximum number of attempts.
              </div>
              <h1 aria-hidden={true} className="account-locked-title">
                You have exceeded the maximum number of attempts.
              </h1>

              <p className="account-locked-description">
                {`Try again after ${coolOffPeriod} minutes.`}
              </p>
            </>
          ) : null}
        </div>
      </div>
    </Container>
  );
};

export default AccountUnlockRecoveryResponse;
